import Swiper from 'swiper'
import { gsap } from 'gsap'
import { EffectFade, Autoplay } from 'swiper/modules'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class Hero {
  constructor(el) {
    this.el = el
    this.swiper = null
    this.slider = document.querySelector('.hero--slider')
    this.content = document.querySelector('.hero--content')
    if (this.slider) this.init()
  }

  init() {
    gsap.fromTo(
      this.slider,
      { scale: 0.8 },
      {
        scale: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: this.el,
          start: 'top 0',
          end: '+=1000',
          scrub: 1,
          markers: false,
        }
      }
    )

    gsap.fromTo(
      this.content,
      { filter: 'blur(80px)' },
      {
        filter: 'blur(0px)',
        ease: 'none',
        immediateRender: false,
        scrollTrigger: {
          trigger: this.content,
          start: 'top 80%',
          end: 'top 20%',
          scrub: .2,
        }
      }
    )
    ScrollTrigger.refresh()

    this.swiper = new Swiper(this.el.querySelector('.swiper'), {
      modules: [EffectFade, Autoplay],
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
    })
  }
}
